import { TypographyRhythm } from '@jouzen/ecom-components/v3/TypographyRhythm';

import RichText from '@/app/components/RichText';
import SectionHeading from '@/app/components/SectionHeading';
import useMembershipPricing from '@/app/hooks/useMembershipPricing';

const PopMembershipContent = () => {
  const membershipPricingValues = useMembershipPricing({
    footnoteSymbol: '**',
  });

  return (
    <div className="pb-12 md:pb-16">
      <div className="flex flex-col gap-12 md:flex-row md:justify-between">
        <SectionHeading
          animated
          className="md:max-w-[540px]"
          content="pop_gen4_membership_title"
          typographyProps={{
            className: 'leading-tighter text-current font-normal',
            Element: 'h2',
            variant: 'h4',
          }}
        />
        <TypographyRhythm className="max-w-[460px]">
          <RichText
            messageKey="pop_become_a_member_copy_ai_update"
            tValues={membershipPricingValues}
          />
        </TypographyRhythm>
      </div>
    </div>
  );
};

export default PopMembershipContent;
